// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"a2b0a68c","726":"dbf6b132"}[chunkId] + ".chunk.js";
};